import actions from './actions';

const initState = {
	dataWriteEssay: [],
	writeEssayDetail: {},
	totalItems: 0,
	loading: false,
};

export default function readAloudReducer(state = initState, action) {
	switch (action.type) {
		case actions.GET_WRITE_ESSAY:
			return { ...state, totalItems: 0, loading: true };
		case actions.GET_WRITE_ESSAY_SUCCESS:
			let { data, totalItems } = action.payload;
			let res = data ? data : [];
			return { ...state, dataWriteEssay: res, totalItems, loading: false };

		case actions.GET_WRITE_ESSAY_DETAIL:
			return { ...state, loading: true, totalItems: 0 };
		case actions.GET_WRITE_ESSAY_DETAIL_SUCCESS: {
			let { data } = action.payload;
			let res = data ? data : {};
			return { ...state, writeEssayDetail: res, loading: false };
		}

		case actions.WRITING_LOADING_FALSE: {
			return { ...state, loading: false };
		}

		default:
			return state;
	}
}
